module.exports = __webpack_public_path__ + "static/media/info.7c807e25.svg";